var map = {
	"./1.png": "./src/assets/img/1.png",
	"./logo copy.png": "./src/assets/img/logo copy.png",
	"./logo.png": "./src/assets/img/logo.png",
	"./pp copy.jpg": "./src/assets/img/pp copy.jpg",
	"./pp.jpg": "./src/assets/img/pp.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*$";